/* Yup validation schemas */
import i18n from "i18n";
import * as Yup from "yup";

/* Add a permanent transport form schema */
export const insertTypeValidationSchema = Yup.object().shape({
  insert_type_id: Yup.number()
    .moreThan(0, i18n.t("mediaRequestDetail.selectInsertType"))
    .required(i18n.t("mediaRequestDetail.thisFieldIsRequired")),
  insert_type: Yup.string(),
  quantity: Yup.number()
    .moreThan(0, i18n.t("mediaRequestDetail.quantityIsInvalid"))
    .required(i18n.t("mediaRequestDetail.thisFieldIsRequired"))
});
